import React from 'react'
import axios from "axios";
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ROUTES from '../../Nav/Routes';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const SupportList = () => {
  // This is for get data list
  const [listOfSupports, setListOfSupports] = useState([]);

  const [currentId, setCurrentId] = useState("");
  const [selectedSupport, setSelectedSupport] = useState(null);

  const notifyDelete = () => toast("Item Deleted Successfully!", {
    hideProgressBar: false,
    pauseOnHover: false,
    hideProgressBar: true,
    style: {
      color: '#008000',
    }
  });


  useEffect(() => {
    axios.get("https://bntserver.bntfoundation.com/SupportListGet.php").then((response) => {
      setListOfSupports(response.data.data);
    })
  }, [])
  let navigate = useNavigate();


  //for delete request
    const deleteSupport = () => {
        // We use FormData and POST because your PHP script expects 'id' in $_POST
        const formData = new FormData();
        formData.append("id", currentId);

        axios.post(`https://bntserver.bntfoundation.com/SupportDelete.php`, formData)
            .then((response) => {
                // Only remove from UI if the server actually confirmed success
                if (response.data.status === "success") {
                    setListOfSupports(listOfSupports.filter(item => item.id !== currentId));
                    notifyDelete();
                } else {
                    toast.error(response.data.message || "Delete failed");
                }
            })
            .catch((err) => {
                console.error(err);
                toast.error("An error occurred while deleting");
            })
            .finally(() => {
                hideDeleteModal();
            });
    }

  const showDeleteModal = (supportId) => {
    document.getElementById("deleteModal").style.display = "block";
    setCurrentId(supportId);
  }

  const hideDeleteModal = () => {
    document.getElementById("deleteModal").style.display = "none";
  }

  const showDetailModal = (support) => {
    setSelectedSupport(support);
    document.getElementById("detailModal").style.display = "block";
  }

  const hideDetailModal = () => {
    document.getElementById("detailModal").style.display = "none";
  }
  
  return (
    <div className='w-100'>
      {/* Delete Modal */}
      <div className="modal " id='deleteModal'>
        <div className="modal-dialog shadow-box" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title ">Confirm Delete</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={hideDeleteModal}>
                <span aria-hidden="true"></span>
              </button>
            </div>
            <div className="modal-body text-dark">
              <p>Are you sure you want to delete?</p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-danger mx-3" onClick={deleteSupport}>Yes</button>
              <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={hideDeleteModal}>No</button>
            </div>
          </div>
        </div>
      </div>

      {/* Detail Modal */}
      <div className="modal" id='detailModal'>
        <div className="modal-dialog modal-lg shadow-box" role="document">
          <div className="modal-content">
            <div className="modal-header bg-primary text-white">
              <h5 className="modal-title">Support Request Detail</h5>
              <button type="button" className="btn-close btn-close-white" onClick={hideDetailModal}></button>
            </div>
            <div className="modal-body text-dark">
              {selectedSupport && (
                <div className="p-2">
                  <div className="mb-3">
                    <strong>Name:</strong> <span className="ms-2">{selectedSupport.name}</span>
                  </div>
                  <div className="mb-3">
                    <strong>Email:</strong> <span className="ms-2">{selectedSupport.email}</span>
                  </div>
                  <div className="mb-3">
                    <strong>Date:</strong> <span className="ms-2">{new Date(selectedSupport.created_at).toLocaleDateString('en-CA', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
                  </div>
                  <hr />
                  <div className="mb-2">
                    <strong>Message:</strong>
                  </div>
                  <div className="p-3 bg-light rounded" style={{ whiteSpace: 'pre-wrap', maxHeight: '400px', overflowY: 'auto' }}>
                    {selectedSupport.message}
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={hideDetailModal}>Close</button>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />

      <h2>Support Request List</h2>

      <table className="table mt-4">
        <thead>
          <tr>
            <th>Name</th>
            <th>E-mail</th>
            <th>Message</th>
            <th>Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {listOfSupports && listOfSupports.map((value, key) => {
            const createdAtDate = new Date(value.created_at);
            const options = { day: 'numeric', month: 'long', year: 'numeric' };
            const formattedDate = createdAtDate.toLocaleDateString('en-CA', options);
            
            // Slice message for display
            const shortMessage = value.message && value.message.length > 50 
              ? value.message.substring(0, 50) + "..." 
              : value.message;

            return (
              <tr key={key}>
                <td>{value.name}</td>
                <td>{value.email}</td>
                <td>
                  <span title={value.message}>
                    {shortMessage}
                  </span>
                </td>
                <td>{formattedDate}</td>
                <td>
                  <div className='text-primary d-inline onHover me-3' onClick={() => showDetailModal(value)}>
                    <i className="fa-solid fa-eye me-1"></i> Detail
                  </div>
                  <div className='text-danger d-inline onHover' onClick={() => showDeleteModal(value.id)}>
                    <i className="fa-solid fa-trash me-1"></i> Delete
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  )
}

export default SupportList;
